import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

/**
 * Fetches current user's Firestore document. Uses TanStack Query for caching and refetch.
 */
export function useUserData() {
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setUserId(user?.uid ?? null);
    });
    return unsub;
  }, []);

  const {
    data: userData,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: ['userData', userId],
    queryFn: async () => {
      const snap = await getDoc(doc(db, 'users', userId));
      if (!snap.exists()) throw new Error('User data not found');
      return snap.data();
    },
    enabled: !!userId,
    staleTime: 30 * 1000,
  });

  const isBrokerOwner = Boolean(
    userData?.isBrokerOwner === true || userData?.role === 'broker_owner'
  );

  return {
    userData: userData ?? null,
    loading: isLoading || isFetching,
    error: error?.message ?? null,
    refetch,
    isBrokerOwner,
  };
}
